import { buildAxiosClient } from '../../../common/models/axiosClient';
import type { AxiosPromise } from 'axios';
import { ResultData } from './resultData';

type FundraisingSimulationData = {
  president_age: number | null;
  birth_on: number | null;
  business_type: number | null;
  requested_funding_amount: number | null;
  total_funding_amount: number | null;
  current_valuation: number | null;
  previous_period_sales: number | null;
  financial_status: number | null;
};

type FundraisingSimulationTag = {
  ids: number[];
};

type SimulateParams = {
  type: string;
  fundraising_simulation: FundraisingSimulationData;
  fundraising_simulation_tag: FundraisingSimulationTag;
};

type CreateParams = {
  type: string;
  fundraising_simulation: FundraisingSimulationData;
  fundraising_simulation_tag: FundraisingSimulationTag;
};

export default class FundraisingSimulationClient {
  simulate(params: SimulateParams): AxiosPromise<ResultData> {
    return buildAxiosClient().post(
      '/api/v1/fundraising_simuration/simulate',
      params,
    );
  }

  create(params: CreateParams): AxiosPromise<void> {
    return buildAxiosClient().post('/api/v1/fundraising_simuration', params);
  }
}
